/* eslint-disable */
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { addDoc, collection, Timestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { useDispatch } from "react-redux";
import { loginUser } from "../../redux/user/user";
import ReactPixel from "react-facebook-pixel";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import DarkModeToggle from "../../components/navbar/DarkModeToggle";
import { states } from "../../constants/algeria_cities";
import {
  moroccoCities,
  tunisiaCities,
  egyptCities,
} from "../../constants/other_cities";
import ProfileManager from "../../utils/profile-manager";

// Function to get referral code from URL
const getReferralFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("ref");
};

function Signup() {
  const [isValid, setIsValid] = useState(false);
  const [isValid1, setIsValid1] = useState(false);
  const [isExist, setIsExist] = useState(true);
  const [userInvitedBy, setUserInvitedBy] = useState("");
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage && savedLanguage !== i18n.language) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };
  const isRTL = i18n.dir() === "rtl";
  const [verifyingCode, setVerifyingCode] = useState(false);
  const [referralVerified, setReferralVerified] = useState(false);

  const [isModalVisible, setModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setIsValid1(true);
    setModalVisible(false);
  };
  const closeModal2 = () => {
    setModalVisible(false);
  };

  const isValueUnique = async (storeName) => {
    try {
      const regex = /[^a-zA-Z0-9-]|-$/;
      if (regex.test(storeName)) {
        setIsValid(false);
        setErrorMessage(t("storeValidation.dash_error"));
        return; // لا تكمل العملية إذا كانت الشروط غير متوافقة
      }

      // استدعاء Cloud Function
      const response = await fetch(
        `https://us-central1-e-commerce-17eb9.cloudfunctions.net/checkstorename?storeName=${loginForm.store}`
      );

      if (!response.ok) {
        throw new Error(t("storeValidation.check_error"));
      }

      const data = await response.json();
      if (!data.unique) {
        setIsValid(false);
        setErrorMessage(data.message || t("storeValidation.name_taken"));
      } else {
        setIsValid(true);
        setErrorMessage("");
      }
    } catch (error) {
      console.error("Error checking uniqueness: ", error);
      setErrorMessage(t("storeValidation.check_error"));
    }
  };
  /** Do security for this api  */
  useEffect(() => {
    fetch("https://ipwhois.pro/?key=GinbIr8YaWazl7FU")
      .then((res) => res.json())
      .then((data) => {
        const country = data.country;
        if (country) {
          setSelectedCountry(country);
          switch (country) {
            case "Algeria":
              setSelectedCurrency("الدينار");
              setSelectedSymbole("دج");
              break;
            case "Bahrain":
              setSelectedCurrency("الدينار البحريني");
              setSelectedSymbole("دب");
              break;
            case "Egypt":
              setSelectedCurrency("الجنيه المصري");
              setSelectedSymbole("ج.م");
              break;
            case "Iraq":
              setSelectedCurrency("الدينار العراقي");
              setSelectedSymbole("دع");
              break;
            case "Jordan":
              setSelectedCurrency("الدينار الأردني");
              setSelectedSymbole("د.أ");
              break;
            case "Kuwait":
              setSelectedCurrency("الدينار الكويتي");
              setSelectedSymbole("د.ك");
              break;
            case "Lebanon":
              setSelectedCurrency("الليرة اللبنانية");
              setSelectedSymbole("ل.ل");
              break;
            case "Libya":
              setSelectedCurrency("الدينار الليبي");
              setSelectedSymbole("ل.د");
              break;
            case "Mauritania":
              setSelectedCurrency("الأوقية الموريتانية");
              setSelectedSymbole("أ.م");
              break;
            case "Morocco":
              setSelectedCurrency("الدرهم المغربي");
              setSelectedSymbole("د.م");
              break;
            case "Oman":
              setSelectedCurrency("الريال العماني");
              setSelectedSymbole("ر.ع");
              break;
            case "Palestine":
              setSelectedCurrency("الشيكل الفلسطيني");
              setSelectedSymbole("₪");
              break;
            case "Qatar":
              setSelectedCurrency("الريال القطري");
              setSelectedSymbole("ر.ق");
              break;
            case "Saudi Arabia":
              setSelectedCurrency("الريال السعودي");
              setSelectedSymbole("ر.س");
              break;
            case "Sudan":
              setSelectedCurrency("الجنيه السوداني");
              setSelectedSymbole("ج.س");
              break;
            case "Syria":
              setSelectedCurrency("الليرة السورية");
              setSelectedSymbole("ل.س");
              break;
            case "Tunisia":
              setSelectedCurrency("الدينار التونسي");
              setSelectedSymbole("د.ت");
              break;
            case "United Arab Emirates":
              setSelectedCurrency("الدرهم الإماراتي");
              setSelectedSymbole("د.إ");
              break;
            case "Yemen":
              setSelectedCurrency("الريال اليمني");
              setSelectedSymbole("ر.ي");
              break;
            default:
              setSelectedCurrency("الدينار");
              setSelectedSymbole("دج");
              break;
          }
        }
      })
      .catch(() => {
        setSelectedCurrency("الدينار");
        setSelectedSymbole("دج");
      });
  }, []);

  const advancedMatching = { em: "some@email.com" };
  const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: false, // enable logs
  };
  ReactPixel.init("815393749574051", advancedMatching, options);
  useEffect(() => {
    ReactPixel.pageView(); // For tracking page view
  }, []);

  const auth = getAuth();
  const dispatch = useDispatch();

  const products = [
    {
      category_id: "كل المنتجات",
      url: "product1",
      name: "اسم المنتج",
      visits: 0,
      image: "",
      review: "4",
      show: "1",
      user: "lcEW4Tv9D3bzgcRxQQa1890Ge4y1",
      price: "1000",
      gallery: [
        "https://firebasestorage.googleapis.com/v0/b/e-commerce-17eb9.appspot.com/o/1666746031360main?alt=media&token=1c9c20bc-8346-41e8-8654-babd2d4d58dc",
      ],
      offers: [
        {
          qty: 0,
          title: "",
          price: 0,
        },
        {
          title: "",
          price: 0,
          qty: 0,
        },
        {
          title: "",
          price: 0,
          qty: 0,
        },
        {
          title: "",
          price: 0,
          qty: 0,
        },
      ],
      oldPrice: "1900",
      sku: "FW02",
      options: [],
      textEditor:
        '<p class="ql-align-center"><span style="color: rgb(0, 0, 0);">هنا سيكون وصف المنتج الخاص بك.*تعليمات حول كتابة وصف احترافي لمنتجك:يمكنك زيارة&nbsp;هذه الصفحة&nbsp;لمعرفة كيفية كتابة وصف إحترافي لمنتجك.يمكنك زيارة&nbsp;هذه الصفحة&nbsp;لمعرفة كيفية اضافة منتج جديد بمتجرك الإلكتروني.يمكنك زيارة&nbsp;هذه الصفحة&nbsp;</span><a href="https://foorweb.net/market/" rel="noopener noreferrer" target="_blank" style="color: rgb(153, 51, 255);">market.foorweb.net</a><span style="color: rgb(0, 0, 0);">&nbsp;&nbsp;</span></p>',
      timeStamp: {
        seconds: 1666746110,
        nanoseconds: 982000000,
      },
      short: "وصف قصير للمنتج ❤️",
      qty: "8",
    },
  ];

  const [loginForm, setLoginForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    store: "",
    invitedBy: "",
    points: 0,
    paidAccount: [],
    invitationActive: "false",
    callName: "",
    foorwebcondition: true,
  });
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedSymbole, setSelectedSymbole] = useState("");
  // Function to check if `invitedBy` exists in Firebase
  const checkInvitedByExists = async (invitedBy) => {
    if (!invitedBy.trim()) {
      setIsExist(true); // Allow submission when invitedBy is empty
      return true;
    }

    try {
      const res = await fetch(
        "https://backend-dash.foorweb.store/api/getAccountWithCallName",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ callName: invitedBy }),
        }
      );

      const data = await res.json();

      const exists = res.ok && data;
      setUserInvitedBy(data.user);
      setVerifyingCode(exists);
      return exists;
    } catch (error) {
      console.error("Error checking invitedBy:", error);
      setVerifyingCode(false);
      return false;
    }
  };

  // Function to handle invitedBy input change
  const handleInvitedByChange = async (e) => {
    const invitedByValue = e.target.value.trim(); // Trim spaces
    setLoginForm((prev) => ({ ...prev, invitedBy: invitedByValue }));

    if (invitedByValue !== "") {
      const exists = await checkInvitedByExists(invitedByValue);
      if (!exists) {
        setErrorMessage(t("referral.not_found"));
      } else {
        // Show success notification
        Swal.fire({
          icon: "success",
          title: t("referral.verified_title"),
          text: t("referral.verified_text"),
          confirmButtonText: t("referral.ok"),
          confirmButtonColor: "#7e5395",
          timer: 3000,
          timerProgressBar: true,
          position: "top-end",
          toast: true,
          showConfirmButton: false,
        });
      }
    } else {
      setVerifyingCode(true); // Ensure empty invitedBy allows submission
      setErrorMessage(""); // Reset error message
    }
  };

  const handleDChange = () => {
    setData({ ...data, foorwebcondition: !data.foorwebcondition });
  };
  const [loginSign, setLoginSign] = useState(false);

  const [error, setError] = useState(false);

  useEffect(() => {
    // Check URL for referral code when component mounts
    const checkReferralCode = async () => {
      const ref = getReferralFromUrl();
      if (ref) {
        setVerifyingCode(true);
        try {
          // Replace verifyReferralCode with checkInvitedByExists
          const isValid = await checkInvitedByExists(ref);

          if (isValid) {
            setLoginForm((prev) => ({
              ...prev,
              invitedBy: ref,
            }));
            setReferralVerified(true);

            // Show success notification
            Swal.fire({
              icon: "success",
              title: t("referral2.verified_title"),
              text: t("referral2.verified_text"),
              confirmButtonText: t("referral.ok"),
              confirmButtonColor: "#7e5395",
              timer: 3000,
              timerProgressBar: true,
              position: "bottom-end",
              toast: true,
              showConfirmButton: false,
            });
          } else {
            // Show error if callName doesn't exist
            Swal.fire({
              icon: "error",
              title: t("referral2.invalid_title"),
              text: t("referral2.invalid_text"),
              confirmButtonText: t("ship.ok"),
              confirmButtonColor: "#7e5395",
            });
          }
        } catch (error) {
          console.error("Error verifying referral code:", error);

          // Show error notification
          Swal.fire({
            icon: "error",
            title: t("referral2.invalid_title"),
            text: t("referral2.invalid_text"),
            confirmButtonText: t("referral.ok"),
            confirmButtonColor: "#7e5395",
          });
        } finally {
          setVerifyingCode(false);
        }
      }
    };

    checkReferralCode();
  }, []);

  const getCountryFlag = (country) => {
    switch (country) {
      case "Algeria":
      case "الجزائر":
        return "/dz.png";
      case "Morocco":
      case "المغرب":
        return "/ma.png";
      case "Egypt":
      case "مصر":
        return "/eg.png";
      case "Tunisia":
      case "تونس":
        return "/tn.png";
      default:
        return "/gb.png";
    }
  };

  const wilayaLabelMap = {
    Algeria: "الولاية",
    Morocco: "المدينة",
    Tunisia: "الولاية",
    Egypt: "المحافظة",
  };

  const communeName = (() => {
    switch (selectedCountry) {
      case "Algeria":
        return t("orders.commune");
      case "Morocco":
        return t("ui.region");
      case "Tunisia":
        return t("orders.commune");
      case "Egypt":
        return t("ui.district");
      default:
        return t("orders.commune");
    }
  })();

  const countryTranslations = {
    Algeria: "الجزائر",
    Morocco: "المغرب",
    Tunisia: "تونس",
    Egypt: "مصر",
    Jordan: "الأردن",
    Iraq: "العراق",
    Lebanon: "لبنان",
    Kuwait: "الكويت",
    Bahrain: "البحرين",
    // أضف باقي الدول حسب حاجتك
  };
  const wilayaLabel = wilayaLabelMap[selectedCountry] || "الولاية";
  const countryInArabic = countryTranslations[selectedCountry] || "الجزائر";
  const domainExtension =
    !countryInArabic || countryInArabic === "الجزائر" ? "store" : "shop";
  const handleSubmit = async (e) => {
    setError(false);
    e.preventDefault();

    if (loginSign) {
      // تسجيل دخول عادي
      signInWithEmailAndPassword(auth, loginForm.email, loginForm.password)
        .then((userCredential) => {
          const user = userCredential.user;
          dispatch(loginUser(user?.uid));
          localStorage.setItem("token", user?.uid);
          setError(false);
        })
        .catch(() => {
          setError(true);
        });
    } else {
      createUserWithEmailAndPassword(auth, loginForm.email, loginForm.password)
        .then((userCredential) => {
          const user = userCredential?.user;

          // إضافة store
          addDoc(collection(db, "store"), {
            user: user?.uid,
            color2: "#ffb43f",
            reqNumber: 5,
            reqTime: 2,
            theme: 2,
            country: countryInArabic ? countryInArabic : "الجزائر",
            currency: "الدينار",
            currencySymbol: selectedSymbole ? selectedSymbole : "دج",
            names: true,
            num: true,
            communewrite: selectedCountry !== "Algeria" && !!selectedCountry,
            categories: [
              "كل المنتجات",
              "التصنيف -1-",
              "التصنيف -2-",
              "التصنيف -3-",
              "التصنيف -4-",
              "https://foorweb.net/1-1",
              "https://foorweb.net/2-1.png",
              "https://foorweb.net/3-1.png",
              "https://foorweb.net/4-1.png",
              "https://foorweb.net/5-1.png",
            ],
            communeName: communeName,
            wilayaName: wilayaLabel,
            delevery: {
              activeCities: true,
              wilaya: true,
              address: true,
              free: false,
              paid: true,
              states: states,
              states2:
                selectedCountry === "Morocco"
                  ? moroccoCities
                  : selectedCountry === "Tunisia"
                  ? tunisiaCities
                  : selectedCountry === "Egypt"
                  ? egyptCities
                  : [],
            },
            googleShit: "",
            color1: "#8760a1",
            title: "Foorweb - أفضل منصة إنشاء متاجر الكترونية",
            arabics: true,
            img: "https://firebasestorage.googleapis.com/v0/b/e-commerce-8f7c7.appspot.com/o/1664392017259main?alt=media&token=2f419d00-81b5-4459-a7fc-c5641b16881c",
            logo: "https://firebasestorage.googleapis.com/v0/b/e-commerce-17eb9.appspot.com/o/1666130495384main?alt=media&token=f3902752-d5b3-424d-b685-393b213eb2e1",
            footer: "حقوق محفوظة ل foorweb",
            visits: 0,
            facebookPixel: "",
            SocialMedia: {
              phone: "066666666",
              facebook: "https://www.facebook.com/F0orweb",
              insta: "https://www.instagram.com/foorweb/",
            },
            texting: {
              thanks:
                '<h2 class="ql-align-right"><strong>شركة فوور ويب تشكرك على التعامل معها سعر التوصيل لكل ولايات الجزائر</strong></h2><p class="ql-align-right"><br></p><p class="ql-align-center"><strong>سيتم الاتصال بك عبر أحد الارقام التالية : 0666666666</strong></p><p class="ql-align-center"><br></p>',
              heading1: "مرحبا بكم في متجر ديمو فوورويب 🚀",
              heading3: "كتابة أي وصف عن متجرك الالكتروني",
              heading2: "تحدث عن علامتك التجارية !",
              return:
                '<p class="ql-align-right"><strong>سياسية الضمان :</strong></p><p class="ql-align-right">تلتزم – بتعويض زبائنها في حالة ما وجد المنتج معطوبا او مكسورا او فيه خلل ، منتجاتنا هي منتجات لشركات رائدة في مجال التجميل و الصحة و كل منتجاتها لديها ترخيص من وزارة الصحة و تخضع للقانون التجاري الجزائري .</p><p class="ql-align-right"><br></p><p class="ql-align-right"><strong>سياسة التوزيع :</strong></p><p class="ql-align-right">يتم الاتصال بالزبون بعد 24 ساعة من وضع الطلبية ، وتاكيدها معه هاتفيا يتم اخذ معلومات الزبون التي قام بكتابتهابمحض ارادته واستعمالها لغرض ايصال الطلبية الى العنوان المتفق عليه ، وتسلم الطلبية في غضون 2-7 ايام على حسب الولاية .</p>',
              pay: '<p class="ql-align-right"><strong>سياسة الدفع :</strong></p><p class="ql-align-right">تنتهج سياسة الدفع عند الاستلام ، اي اننا لا نطلب من الزبون دفع اي مبلغ مسبق ونعتمد على الثقة المتبادلة بين الشركة وزبائنها ، يتم دفع ثمن المنتج عند تسليمه فقط ، و ترفق فاتورة المنتج معه موقعة ومصادق عليها من طرف الشركة .</p>',
            },
          }).then(async () => {
            const urlParams = new URLSearchParams(window.location.search);

            // يكفي وجود البارام digitalProducts باش يكون true
            const isActiveDigitalProducts = urlParams.has("digitalProducts");
            // إضافة account
            await addDoc(collection(db, "account"), {
              store: `https://${loginForm.store}.foorweb.${domainExtension}/`,
              storeName: `https://${loginForm.store}.foorweb.store/`,
              phone: loginForm.phone,
              birthDay: "1998-07-06",
              name: loginForm.name,
              user: user?.uid,
              email: loginForm?.email,
              country: countryInArabic,
              invitedBy: loginForm.invitedBy,
              userInvitedBy: userInvitedBy || null,
              invitationActive: userInvitedBy ? true : false,
              points: 0,
              subscription: {
                endDate: Timestamp.fromDate(new Date(`2023-02-01T00:00:00Z`)),
                plan: "الاساسية",
                tokens: 30,
              },
              ...(isActiveDigitalProducts && {
                productMode: "digital",
                isActiveDigitalProducts: isActiveDigitalProducts,
                isPhoneVerified: true,
              }),
            });

            if (isActiveDigitalProducts) {
              // إضافة digitalStore فقط إذا ?digitalProducts=true
              await addDoc(collection(db, "digitalStore"), {
                user: user?.uid,
                color2: "#ffb43f",
                categories: [
                  "كل المنتجات",
                  "التصنيف -1-",
                  "التصنيف -2-",
                  "التصنيف -3-",
                  "التصنيف -4-",
                  "https://foorweb.net/1-1",
                  "https://foorweb.net/2-1.png",
                  "https://foorweb.net/3-1.png",
                  "https://foorweb.net/4-1.png",
                  "https://foorweb.net/5-1.png",
                ],
                googleShit: "",
                isActiveDigitalProducts: true,
                color1: "#8760a1",
                title: "Foorweb - Digital Store",
                arabics: true,
                img: "https://firebasestorage.googleapis.com/v0/b/e-commerce-8f7c7.appspot.com/o/1664392017259main?alt=media&token=2f419d00-81b5-4459-a7fc-c5641b16881c",
                logo: "https://firebasestorage.googleapis.com/v0/b/e-commerce-17eb9.appspot.com/o/1666130495384main?alt=media&token=f3902752-d5b3-424d-b685-393b213eb2e1",
                footer: "حقوق محفوظة ل foorweb",
                visits: 0,
                facebookPixel: "",
                SocialMedia: {
                  phone: "066666666",
                  facebook: "https://www.facebook.com/F0orweb",
                  insta: "https://www.instagram.com/foorweb/",
                },
                texting: {
                  thanks: "<p>شكراً لتجربتك متاجر Foorweb الرقمية</p>",
                },
                paymentMethods: {
                  binance: { enabled: false },
                  paypal: { enabled: false },
                  stripe: { enabled: false },
                  paymentLater: { enabled: true },
                },
              });
            }

            // إضافة منتجات افتراضية
            products.forEach((element, index) => {
              addDoc(collection(db, "products"), {
                ...element,
                user: user?.uid,
              }).then(() => {
                if (index === products.length - 1) {
                  // save profile using ProfileManager
                  // ProfileManager.saveProfile({
                  //   uid: user?.uid,
                  //   email: loginForm.email,
                  //   name: loginForm.name,
                  //   photoUrl: null,
                  // });

                  // store credentials for profile switching
                  // ProfileManager.storeCredentials({
                  //   uid: user?.uid,
                  //   email: loginForm.email,
                  //   password: loginForm.password,
                  // });

                  dispatch(loginUser(user?.uid));
                  localStorage.setItem("token", user?.uid);
                }
              });
            });

            ReactPixel.track("Purchase", 2900);
          });
        })
        .catch(() => {
          setError(true);
        });
    }
  };

  useEffect(() => {
    if (
      loginForm.store.length < 4 ||
      /[.\u00BF-\u00FF]/.test(loginForm.store)
    ) {
      setErrorMessage(t("signup.error1"));
      setIsValid(false);
    } else {
      // alert(`https://${loginForm.store}.foorweb.store/`);
      isValueUnique(
        "account",
        "store",
        `https://${loginForm.store}.foorweb.store/`,
        loginForm.store
      );
      const newValue = loginForm.store.replace(/\s+/g, "-");
      setLoginForm({ ...loginForm, store: newValue, storeName: newValue });
    }
  }, [loginForm.store, i18n.language]);

  const [hidePassword, setHidePassword] = useState(true);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const rememberMeValue = localStorage.getItem("rememberMe") === "true";
    setRememberMe(rememberMeValue);
  }, []);

  const handleCheckboxChange = (event) => {
    setIsValid1(event.target.checked);
  };

  return (
    <main
      className="w-full flex relative overflow-hidden dark:bg-[#141414] dark:text-gray-200"
      dir={i18n.dir()}
    >
      {/* Referral Banner */}
      {((loginForm.invitedBy && referralVerified && !loginSign) ||
        (loginForm.invitedBy && verifyingCode && !loginSign)) && (
        <div className="z-[99999] referral-banner bg-green-100 p-3 mb-4 rounded-lg text-center absolute bottom-2 right-5 dark:bg-green-900/20">
          <p className="text-green-800 text-right dark:text-green-300">
            {t("signup.referral_banner.invited_by")}{" "}
            <strong>{loginForm.invitedBy}</strong>
          </p>
          <p className="text-sm text-green-700 mt-1 text-end dark:text-green-400">
            {t("signup.referral_banner.discount_notice")}
          </p>
        </div>
      )}

      {/* Left Banner */}
      <div className="relative flex-1 hidden items-center justify-center h-screen bg-gray-900 overflow-hidden lg:flex">
        <div className="relative z-10 w-full max-w-md">
          <img src="/logowhite.png" width={150} alt={t("ui.logo")} />
          <div className="mt-16 space-y-3">
            <h3 className="text-white text-3xl font-bold">
              {t("signup.side_banner.title")}
            </h3>
            <p className="text-gray-300">
              {t("signup.side_banner.description")}
            </p>

            {/* Avatars + Text */}
            <div className="flex items-center gap-3 -space-x-2 overflow-hidden">
              <div className="flex items-center -space-x-2 overflow-hidden">
                {[
                  "https://randomuser?.me/api/portraits/women/79.jpg",
                  "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
                  "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=a72ca28288878f8404a795f39642a46f",
                  "https://randomuser?.me/api/portraits/men/86.jpg",
                  "https://images.unsplash.com/photo-1510227272981-87123e259b17?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=3759e09a5b9fbe53088b23c615b6312e",
                ].map((src, idx) => (
                  <img
                    key={idx}
                    src={src}
                    alt={t("ui.userNumber", { value0: (idx + 1) })}
                    className="rounded-lg overflow-hidden shadow-sm w-10 h-10 bg-[#faf1ff] border-2 border-white"
                  />
                ))}
              </div>
              <p
                dir={i18n.dir()}
                className={`text-sm text-gray-400 font-medium ${
                  i18n.dir() === "rtl"
                    ? "mr-[-10px] text-right"
                    : "ml-[-10px] text-left"
                }`}
              >
                {t("login.hero.join_merchants")}
              </p>
            </div>
          </div>
        </div>

        <div
          className="absolute inset-0 my-auto h-[500px]"
          style={{
            background:
              "linear-gradient(152.92deg, rgba(192, 132, 252, 0.2) 4.54%, rgba(232, 121, 249, 0.26) 34.2%, rgba(192, 132, 252, 0.1) 77.55%)",
            filter: "blur(118px)",
          }}
        ></div>
      </div>

      {/* Right Signup Form */}
      <div className="flex-1 flex items-center justify-center relative">
        <div className="absolute top-4 w-full px-4 flex justify-between z-50">
          {/* Select langue */}
          <div className={`${isRTL ? "order-2" : "order-1"}`}>
            <select
              onChange={(e) => handleLanguageChange(e.target.value)}
              className="px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-purple-600 dark:bg-[#1b1b1b] dark:!border-[#3c3a3d] dark:text-gray-200"
              value={i18n.language}
            >
              <option value="ar">{t("login.language.ar")}</option>
              <option value="fr">{t("login.language.fr")}</option>
              <option value="en">{t("login.language.en")}</option>
            </select>
          </div>

          {/* Toggle dark mode */}
          <div className={`${isRTL ? "order-1" : "order-2"}`}>
            <DarkModeToggle />
          </div>
        </div>

        <div className="max-w-sm w-full text-gray-600 space-y-5">
          <div className="text-center pb-8">
            <img src="/Logo.png" width={150} alt={t("ui.logo")} className="mx-auto" />
            <h3 className="text-gray-800 text-2xl font-bold sm:text-3xl dark:text-gray-100 mt-5">
              {t("signup.form.title")}
            </h3>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Full Name */}
            <div>
              <label className="font-medium dark:text-gray-200">
                {t("signup.form.full_name")}
              </label>
              <input
                value={loginForm.name}
                onChange={(e) =>
                  setLoginForm({ ...loginForm, name: e.target.value })
                }
                placeholder={t("signup.form.full_name_placeholder")}
                required
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg  dark:!border-[#3c3a3d] dark:text-gray-200"
              />
            </div>

            {/* Email */}
            <div>
              <label className="font-medium dark:text-gray-200">
                {t("signup.form.email")}
              </label>
              <input
                type="email"
                value={loginForm.email}
                onChange={(e) =>
                  setLoginForm({ ...loginForm, email: e.target.value })
                }
                placeholder={t("signup.form.email_placeholder")}
                required
                className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg  dark:!border-[#3c3a3d] dark:text-gray-200"
              />
              {error && (
                <span className="text-red-500 text-sm">
                  {t("signup.form.email_exists")}
                </span>
              )}
            </div>

            {/* Phone */}
            <label className="font-medium dark:text-gray-200">
              {t("signup.form.phone")}
            </label>
            <div className="relative w-full mt-2">
              <img
                src={getCountryFlag(selectedCountry)}
                alt={t("ui.countryFlag")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-auto"
              />
              <input
                dir={i18n.dir()}
                value={loginForm.phone}
                onChange={(e) =>
                  setLoginForm({
                    ...loginForm,
                    phone: e.target.value.replace(/[^0-9]/g, ""), // يسمح فقط بالأرقام
                  })
                }
                type="tel"
                placeholder={t("signup.form.phone_placeholder")}
                required
                className="w-full pr-10 pl-3 py-2 text-gray-500 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg dark:!border-[#3c3a3d] dark:text-gray-200"
              />
            </div>

            {/* Password */}
            <div>
              <label className="font-medium dark:text-gray-200">
                {t("signup.form.password")}
              </label>
              <div className="relative">
                <input
                  type={hidePassword ? "password" : "text"}
                  value={loginForm.password}
                  onChange={(e) =>
                    setLoginForm({ ...loginForm, password: e.target.value })
                  }
                  placeholder={t("signup.form.password_placeholder")}
                  required
                  className="w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg  dark:!border-[#3c3a3d] dark:text-gray-200"
                />
                <button
                  type="button"
                  className={`absolute inset-y-0 ${
                    isRTL ? "left-0" : "right-0"
                  } flex items-center px-4 bg-transparent`}
                  onClick={() => setHidePassword(!hidePassword)}
                >
                  {/* Eye icons (idem login) */}
                  {hidePassword ? /* ... */ null : /* ... */ null}
                </button>
              </div>
            </div>

            {/* Store Name */}
            <div>
              <label className="font-medium dark:text-gray-200">
                {t("signup.form.store_name")}
              </label>
              <div
                className="flex items-center text-gray-400 rounded-md"
                style={{
                  border: "2px solid",
                  borderColor: isValid ? "#00A886" : "#e87778",
                }}
              >
                <div className="px-3 py-2.5 rounded-l-md bg-gray-50 border-r dark:bg-[#222]  dark:!border-[#3c3a3d]">
                  {t("signup.form.store_prefix")}
                </div>
                <input
                  value={loginForm.store}
                  onChange={(e) =>
                    setLoginForm({
                      ...loginForm,
                      store: e.target.value.toLowerCase(),
                    })
                  }
                  type="text"
                  placeholder={t("signup.form.store_placeholder")}
                  required
                  className="px-3 py-2 text-gray-500 bg-transparent outline-none shadow-sm rounded-lg dark:text-gray-200"
                />
              </div>
              {!isValid && (
                <p className="text-red-500 text-sm">{errorMessage}</p>
              )}
            </div>

            {/* Referral Code */}
            <div>
              <label className="font-medium dark:text-gray-200">
                {t("signup.form.invited_by")}{" "}
                <span className="text-gray-400">
                  {t("signup.form.invited_by_optional")}
                </span>
              </label>
              <input
                value={loginForm.invitedBy}
                onChange={handleInvitedByChange}
                placeholder={t("signup.form.invited_by_placeholder")}
                className={`w-full mt-2 px-3 py-2 text-gray-500 bg-transparent outline-none border focus:ring-purple-400 shadow-sm rounded-lg
            ${getReferralFromUrl() ? "bg-gray-100" : ""}
            ${
              referralVerified ? "border-green-500" : ""
            }  dark:!border-[#3c3a3d] dark:text-gray-200`}
              />
              {!isExist && (
                <p className="text-red-500 text-sm">{errorMessage}</p>
              )}
            </div>

            {/* Consent */}
            <div className="flex items-center whitespace-nowrap gap-x-1">
              <Form.Check
                inline
                name="group1"
                type="checkbox"
                className="mx-1"
                onChange={handleCheckboxChange}
              />
              <span>{t("signup.form.privacy.consent")}&nbsp;</span>

              <button
                type="button"
                className="font-medium text-[#9e68ba] hover:text-[#55266d] p-0 bg-transparent border-0 cursor-pointer"
                onClick={openModal}
              >
                {t("signup.form.privacy.policy")}
              </button>
            </div>
            {isModalVisible && (
              <div className="fixed inset-0 z-10 overflow-y-auto">
                <div
                  className="fixed inset-0 w-full h-full bg-black opacity-40"
                  onClick={closeModal}
                ></div>
                <div className="flex items-center min-h-screen px-4 py-8">
                  <div className="relative w-full max-w-lg mx-auto bg-white dark:bg-[#1b1b1b] rounded-md shadow-lg">
                    <div className="flex items-center justify-between p-4 border-b dark:border-gray-600">
                      <h4 className="text-lg font-medium text-gray-800 dark:text-gray-200">
                        {t("signup.form.privacy.modal.title")}
                      </h4>
                    </div>

                    <div className="space-y-2 p-4 mt-3 text-[15.5px] leading-relaxed text-gray-500 dark:text-gray-400 max-h-96 overflow-y-auto">
                      <div className="feature-container">
                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.introduction.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.introduction.content")}
                          <li>
                            {t("signup.form.privacy.link.label")}:{" "}
                            <a
                              href={"https://admin.foorweb.store/sign-up"}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-blue-500 hover:text-blue-700 underline"
                            >
                              https://admin.foorweb.store/sign-up
                            </a>
                          </li>
                          {t("signup.form.privacy.introduction.footer")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.account.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.account.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.meaning.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.meaning.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.activation.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.activation.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.rights.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.rights.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.responsibilities.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.responsibilities.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t(
                            "signup.form.privacy.responsibilities.meaning.title"
                          )}
                        </h3>
                        <p className="mb-4">
                          {t(
                            "signup.form.privacy.responsibilities.meaning.content"
                          )}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.liability.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.liability.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.liability.meaning.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.liability.meaning.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.free.package.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.free.package.content")}
                        </p>

                        <h3 className="positive-guidance-title text-gray-800 dark:text-gray-200 font-semibold">
                          {t("signup.form.privacy.intellectual.title")}
                        </h3>
                        <p className="mb-4">
                          {t("signup.form.privacy.intellectual.content")}
                        </p>
                      </div>
                    </div>

                    {/* Footer avec boutons */}
                    <div className="flex justify-center gap-3 p-4 mt-5 border-t dark:border-gray-600">
                      <button
                        className="px-6 py-2 text-white bg-indigo-600 hover:bg-indigo-700 rounded-md outline-none ring-offset-2 ring-indigo-600 focus:ring-2 transition-colors"
                        onClick={closeModal}
                      >
                        {t("signup.form.privacy.modal.agree")}
                      </button>
                      <button
                        className="px-6 py-2 text-gray-800 dark:text-gray-200 border dark:border-gray-600 rounded-md outline-none ring-offset-2 ring-indigo-600 focus:ring-2 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                        onClick={closeModal2}
                      >
                        {t("signup.form.privacy.modal.cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Button
              variant="primary"
              disabled={!isValid || !isValid1 || !isExist}
              className="w-full px-4 py-2 text-white font-medium bg-[#9b59bf] hover:bg-indigo-500 active:bg-[#9b59bf] rounded-lg duration-150"
              style={{ backgroundColor: "#8961A1" }}
              type="submit"
            >
              {t("signup.form.submit")}
            </Button>
          </form>

          {/* Already have account */}
          <p className="text-center dark:text-gray-300">
            {t("signup.form.already_have_store")}{" "}
            <Link
              to={`/Login`}
              className="font-medium text-[#9e68ba] hover:text-[#55266d]"
            >
              {t("signup.form.login_now")}
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}

export default Signup;